import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20background%20with%20warm%20golden%20wave%20patterns%20on%20the%20bottom%20half%2C%20elegant%20gradient%20from%20dark%20to%20warm%20amber%2C%20cinematic%20atmospheric%20lighting%2C%20premium%20feel%2C%20suitable%20for%20call%20to%20action%20section%20background%2C%20no%20text%2C%20no%20logos&width=1600&height=700&seq=cta-kaiyun-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/80 to-background-50/30"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
          准备好开启您的<strong className="text-primary-500">精彩体验</strong>了吗？
        </h2>
        <p className="text-base text-secondary-600 mb-8 max-w-xl mx-auto">
          立即注册开云平台，享受安全、稳定、极致的在线娱乐体验。专业团队全天候为您服务。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
          >
            立即注册
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg border border-secondary-400/40 text-foreground-800 font-medium text-base hover:bg-background-200/40 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}